import { createFileRoute, Outlet } from "@tanstack/react-router";

import { authenticate, fetchUserAnalytics } from "@/api/api";
import { applicationSettingsQueryOptions } from "@/hooks/useApplicationSettings";
import { bannersPlacementsQueryOptions } from "@/hooks/useBannersPlacement";
import { CommonTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";

export const Route = createFileRoute("/_authenticated")({
  component: RouteComponent,
  beforeLoad: async () => {
    const accessToken = await authenticate();
    void fetchUserAnalytics(accessToken);
  },
  loader: ({ context }) => {
    // Prefetch all placements in the background without blocking navigation
    void context.queryClient.prefetchQuery(bannersPlacementsQueryOptions());
    void context.queryClient.prefetchQuery(applicationSettingsQueryOptions());
  },
  onEnter: () => {
    rudderAnalytics.track(CommonTrackingEvents.USER_OPENED_APP);
  },
});

function RouteComponent() {
  return <Outlet />;
}
